import * as React from 'react';
import { compose } from 'recompose';
import { withApollo, graphql } from 'react-apollo';
import { GetUser } from '../../queries/user';
import MainLayout from '../Layouts/MainLayout';

const PropTest: React.SFC = () => <MainLayout>PropTest.</MainLayout>;

export default compose(
  withApollo,
  graphql(GetUser, {
    props: (props: any) => {
      console.log('PROPS:DATA', props.data);
      return {};
    },
  }),
)(PropTest);



// WEBPACK FOOTER //
// ./src/containers/Pages/PropTest.tsx